import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import {Lock, Publish, Share} from '@mui/icons-material';

// Small reusable share-link button used in both the non-guess and guess room headers.
export function ShareButton({room, compact}) {
    const {t} = useTranslation();
    const [copied, setCopied] = useState(false);
    const onClick = () => {
        const cleanUrl = window.location.origin + '/room/' + room;
        navigator.clipboard.writeText(cleanUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }).catch(() => {});
    };
    const padding = compact ? '2px 6px' : '2px 8px';
    const fontSize = compact ? 10 : 11;
    const iconSize = compact ? 12 : 13;
    return (
        <Tooltip title={copied ? t('drawing.roomLinkCopied', 'Link copied!') : t('drawing.copyRoomLink', 'Copy room link')} placement="bottom">
            <button
                style={{
                    marginLeft: compact ? 0 : 'auto',
                    display: 'flex', alignItems: 'center', gap: 3,
                    padding, cursor: 'pointer',
                    background: 'none', border: 'none', borderRadius: 4,
                    color: copied ? '#7f7' : '#bbc', fontSize, fontFamily: 'monospace',
                    flexShrink: 0,
                }}
                onClick={onClick}
            >
                <Share style={{fontSize: iconSize}}/>
                {compact
                    ? (copied && <span>{t('drawing.roomLinkCopied', 'Link copied!')}</span>)
                    : (copied ? t('drawing.roomLinkCopied', 'Link copied!') : t('drawing.share', 'Share'))}
            </button>
        </Tooltip>
    );
}

export function PublishButton({onPublish, publishPending, compact}) {
    const {t} = useTranslation();
    if (!onPublish) return null;
    const padding = compact ? '2px 6px' : '2px 8px';
    const fontSize = compact ? 10 : 11;
    const iconSize = compact ? 12 : 13;
    return (
        <button
            style={{
                display: 'flex', alignItems: 'center', gap: 3,
                padding, cursor: 'pointer',
                background: 'none', border: 'none', borderRadius: 4,
                color: publishPending ? '#7f7' : '#bbc', fontSize, fontFamily: 'monospace',
                flexShrink: 0,
            }}
            onClick={onPublish}
        >
            <Publish style={{fontSize: iconSize}}/>
            {t('drawing.publish', 'Publish')}
        </button>
    );
}

// Header shown in non-guess (free draw) mode: home button, lock indicator,
// share + publish buttons.
export default function RoomHeader({
    room, homeButton, isOwner, isPrivate,
    isMobile, isMobileLandscape, isSpectator,
    onPublish, publishPending,
}) {
    if (!room) return null;
    const padding = (isMobile || isSpectator) && !isMobileLandscape
        ? "0 0 2px 8px"
        : isMobileLandscape ? "0 0 0 4px" : "0 0 2px 8px";
    const barMinHeight = isMobileLandscape ? 38 : isMobile ? 38 : 42;
    return (
        <div style={{
            display: 'flex', alignItems: 'center', fontSize: 11, color: "#eee",
            padding, fontFamily: "monospace", gap: 2,
            maxWidth: '100vw', boxSizing: 'border-box',
            minHeight: barMinHeight,
            background: '#2a2a3e', borderBottom: '2px solid #444',
        }}>
            {homeButton}
            {!isOwner && isPrivate && (
                <Lock style={{fontSize: 13, marginLeft: 4, opacity: 0.5}}/>
            )}
            <ShareButton room={room}/>
            <PublishButton onPublish={onPublish} publishPending={publishPending}/>
        </div>
    );
}
